import elementTextFilter from '../../../../modules/Gull/Framework/elementTextFilter.js';

const editView = {

	init() {

		var elementTextFilterElement = document.querySelector('[data-element-text-filter-input]');
		elementTextFilter.init(elementTextFilterElement);

	}
};

export default editView;